module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pl":{"title":"Sposoby płatności","data":{"payu":"PayU","montonio":"Montonio","blik":"BLIK","creditCard":"Karta płatnicza"}},"en":{"title":"Payment Methods","data":{"payu":"PayU","montonio":"Montonio","blik":"BLIK","creditCard":"Payment Card"}}}')
  delete Component.options._Ctor
}
